<template>
  <v-container id="simulations_container" class="mt-10">
    <Loading :loading="loading" />
    <span v-if="!loading">
      <v-col>
        <v-alert text dense color="primary" icon="mdi-flask-outline" class="mb-2">
          <div class="d-flex flex-wrap align-center">
            <span class="flex-grow-1 mr-2 my-1">
              New here? Open a ready-to-run example (photonic crystal sensors, ring resonator,
              Gaussian beam) and compare your results with the literature.
            </span>
            <v-btn small color="primary" elevation="0" class="my-1" to="/examples">See examples</v-btn>
          </div>
        </v-alert>
      </v-col>
      <v-col>  
        <v-row v-if="simulations.length >= 1">
          <v-col>
            <p class="text-subtitle-1 mb-0">2D simulations (Meep)</p>
          </v-col>
        </v-row>
        <v-row v-if="simulations.length < 1" justify="center">
          <v-col cols="12" sm="8" md="6" class="text-center">
            <v-img src="/img/illustrations/empty.svg" max-width="160" class="mb-3 mx-auto"></v-img>
            <h2 class="text-h6">No 2D simulations yet</h2>
            <p class="text-body-2">
              Create one with the <v-icon small>mdi-square-outline</v-icon> button in the top bar,
              or start from an example.
            </p>
          </v-col>
        </v-row>
        <div>
          <v-row>
            <v-col
              cols="12"
              v-for="simulation in simulations"
              :key="simulation.id"
            >
              <SimulationCard :simulation="simulation" />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col>
        <v-row v-if="simulations3d.length >= 1">
          <v-col>
            <p class="text-subtitle-1 mb-0">3D simulations (Gmsh + NGSolve)</p>
          </v-col>
        </v-row>
        <v-row v-if="simulations3d.length < 1" justify="center">
          <v-col cols="12" sm="8" md="6" class="text-center">
            <v-img src="/img/illustrations/empty.svg" max-width="160" class="mb-3 mx-auto"></v-img>
            <h2 class="text-h6">No 3D simulations yet</h2>
            <p class="text-body-2">
              Create one with the <v-icon small>mdi-cube-outline</v-icon> button in the top bar.
            </p>
          </v-col>
        </v-row>
        <div>
          <v-row>
            <v-col
              cols="12"
              v-for="simulation in simulations3d"
              :key="simulation.id"
            >
              <SimulationCard :simulation="simulation" :is3d="true" />
            </v-col>
          </v-row>
        </div>
      </v-col>
    </span>
  </v-container>
</template>

<script>
import api from "@/services/api.js";
import Swal from "sweetalert2";
import SimulationCard from "@/components/SimulationCard";

import { mapGetters } from "vuex";

import Loading from "@/components/Loading";
import simulator3d from "@/services/simulator3d";

export default {
  name: "Simulations",
  components: {
    Loading,
    SimulationCard
  },
  data: () => ({
    simulations: [],
    simulations3d: [],
    editedIndex: null,
    dialog: false,
    loading: true,
    currentSimulation: "",
    selectedSimulationURL: "",
    shareModal: false,
    loadingDelete: false
  }),
  watch: {
    editedIndex: function() {
      this.dialog = !this.dialog;
    }
  },
  mounted: function() {
    this.getData();
    this.get3dData();
    this.setPageInfo();
  },
  computed: {
    ...mapGetters("simulator", ["author"])
  },
  methods: {
    share: function(address) {
      this.selectedSimulationURL = address;
      this.shareModal = true;
    },
    setPageInfo: function() {
      document.title = "Your simulations - ElectrosFI";
      document
        .querySelector('meta[name="description"')
        ?.setAttribute(
          "content",
          "Simulate and edit photonic tools online - ElectrosFI"
        );
    },
    getData: async function() {
      try {
        const { data } = await api.get(`/author/${this.author}`);
        
        if (data.error) throw new Error(data.message);
        this.simulations = await data.data.reverse();

        this.loading = false;
      } catch (err) {
        Swal.fire({ title: "An error appears", text: err.message });
      }
    },

    get3dData: async function() {
      try {
        const { data } = await simulator3d.get(`/author/${this.author}`);
        
        if (data.error) throw new Error(data.message);
        this.simulations3d = await data.data.reverse();

        this.loading = false;
      } catch (err) {
        Swal.fire({ title: "An error appears", text: err.message });
      }
    }
  }
};
</script>
<style lang="scss">
#loading {
  height: 100vh;
}
</style>
